/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/vin/VINScannerIntroScreenConfiguration.yaml
import { BackgroundStyle, ButtonConfiguration, ForegroundStyle, StyledText } from '../common/Common';
/** @internal */
export var VinScannerIntroImage;
(function (VinScannerIntroImage) {
    /** @internal */
    function from(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'VINIntroDefaultImage':
                return new VinIntroDefaultImage(source);
            case 'VINIntroNoImage':
                return new VinIntroNoImage(source);
            case 'VINIntroCustomImage':
                return new VinIntroCustomImage(source);
            default:
                throw new Error(`Unknown child class name: ${_type}`);
        }
    }
    VinScannerIntroImage.from = from;
})(VinScannerIntroImage || (VinScannerIntroImage = {}));
/**
The default image for the introduction screen.
*/
export class VinIntroDefaultImage {
    /** @param source {@displayType `DeepPartial<VinIntroDefaultImage>`} */
    constructor(source = {}) {
        this._type = 'VINIntroDefaultImage';
    }
}
/**
No image for the introduction screen.
*/
export class VinIntroNoImage {
    /** @param source {@displayType `DeepPartial<VinIntroNoImage>`} */
    constructor(source = {}) {
        this._type = 'VINIntroNoImage';
    }
}
/**
A custom image for the introduction screen.
*/
export class VinIntroCustomImage {
    /** @param source {@displayType `DeepPartial<VinIntroCustomImage>`} */
    constructor(source = {}) {
        this._type = 'VINIntroCustomImage';
        if (source.uri !== undefined) {
            this.uri = source.uri;
        }
        else {
            throw new Error('uri must be present in constructor argument');
        }
    }
}
/**
Configuration of the introduction screen for the VIN scanner.
*/
export class VinScannerIntroScreenConfiguration {
    /** @param source {@displayType `DeepPartial<VinScannerIntroScreenConfiguration>`} */
    constructor(source = {}) {
        /**
          The image for the introduction screen.
          */
        this.image = new VinIntroDefaultImage({});
        /**
          The background color of the introduction screen.
          
          Default is "?sbColorSurface"
          */
        this.backgroundColor = '?sbColorSurface';
        /**
          The divider color of the introduction screen.
          
          Default is "?sbColorOutline"
          */
        this.dividerColor = '?sbColorOutline';
        /**
          The handle color of the introduction screen.
          
          Default is "?sbColorOutline"
          */
        this.handlerColor = '?sbColorOutline';
        /**
          Determines whether the introduction screen should automatically be shown or not when the scanning session starts.
          
          Default is false
          */
        this.showAutomatically = false;
        /**
          The title of the introduction screen, located in the top bar.
          */
        this.title = new StyledText({ text: '?introScreenTitle', color: '?sbColorOnSurface' });
        /**
          The text explanation of the introduction screen.
          */
        this.explanation = new StyledText({ text: '?introScreenText', color: '?sbColorOnSurface' });
        /**
          Configuration of the 'Done' / 'Start scanning' button.
          */
        this.doneButton = new ButtonConfiguration({
            text: '?introScreenDoneButton',
            accessibilityDescription: '?accessibilityDescriptionIntroScreenDoneButton',
            background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '?sbColorPrimary', strokeWidth: 0.0 }),
            foreground: new ForegroundStyle({ color: '?sbColorOnPrimary' }),
        });
        if (source.image !== undefined) {
            this.image = VinScannerIntroImage.from(source.image);
        }
        if (source.backgroundColor !== undefined) {
            this.backgroundColor = source.backgroundColor;
        }
        if (source.dividerColor !== undefined) {
            this.dividerColor = source.dividerColor;
        }
        if (source.handlerColor !== undefined) {
            this.handlerColor = source.handlerColor;
        }
        if (source.showAutomatically !== undefined) {
            this.showAutomatically = source.showAutomatically;
        }
        if (source.title !== undefined) {
            this.title = new StyledText(source.title);
        }
        if (source.explanation !== undefined) {
            this.explanation = new StyledText(source.explanation);
        }
        if (source.doneButton !== undefined) {
            this.doneButton = new ButtonConfiguration(source.doneButton);
        }
    }
}
//# sourceMappingURL=VinScannerIntroScreenConfiguration.js.map